module.exports = __webpack_public_path__ + "static/media/LoomisExpress.6ee5d744.svg";